import { formatHelper } from "helper/format";
import _get from "lodash.get";
import { readCkycVerificationFromDetails } from "helper/kycDocumentUpload";

const jarvisOnestockOnboardingParser = {};

jarvisOnestockOnboardingParser.brokerList = (res) => {
    if (res && res.data) {
        res = res.data;
    }
    if (!res) {
        return [];
    }

    res.list = res.list.map((p) => ({
        brokerId: _get(p, "brokerId", null),
        brokerName: _get(p, "brokerName", null),
        brokerDisplayName: _get(p, "brokerDisplayName", null),
        brokerPlatform: _get(p, "brokerPlatform", null),
        brokerIcon: formatHelper.getLegacyImageURI(_get(p, "brokerIcon", null)),
        brokerCode: _get(p, "brokerCode", null),
    }));

    res.records = _get(res, "records", 0);
    return res;
};


jarvisOnestockOnboardingParser.onboardingData = (res) => {
    if (res && res.response) {
        res = res.response;
    }

    if (res && res.result) {
        res = res.result;
    }

    if (!res || !Object.keys(res).length) {
        return {};
    }

    const coerceFlag = (value) => {
        if (value === undefined || value === null || value === "") {
            return null;
        }
        return value === true || value === 1 || value === "1" ? 1 : 0;
    };

    return {
        currentStage: _get(res, "currentOnboardingStage", null),
        isOnboardingCompleted: coerceFlag(_get(res, "isOnboardingCompleted", null)),
        isPaymentCompleted: coerceFlag(_get(res, "isPaymentCompleted", null)),
        riskProfileId: _get(res, "riskProfileId", null),
        riskProfileName: _get(res, "riskProfileName", null),
        panNumber: _get(res, "panNumber", null) || _get(res, "pancardNumber", null),
        dateOfBirth: _get(res, "dateOfBirth", null) || _get(res, "dob", null),
        aadharNumber:
            _get(res, "aadharNumber", null) || _get(res, "aadhaarNumber", null),
        isManualKYC: _get(res, "isManualKYC", null),
        isPanUploaded: _get(res, "isPanUploaded", null),
        isAadhaarFrontUploaded: _get(res, "isAadhaarFrontUploaded", null),
        isAadhaarBackUploaded:
      _get(res, "isAadhaarBackUploaded", null) ||
      _get(res, "isAadharBackUploaded", null) ||
      _get(res, "aadharCardBackUploaded", null) ||
      _get(res, "aadhaarCardBackUploaded", null),
        documentStatus: _get(res, "documentStatus", null),
        ...readCkycVerificationFromDetails(res),
        duplicateStages: _get(res, "duplicateStages", null),
        portfolioId: _get(res, "tempCustomerPortfolioId", null),
        customerValueAddedPlanId: _get(res, "customerValueAddedPlanId", null),
        sourceType: _get(res, "sourceType", null),
        isAllInOneSubscriptionActive: _get(res, "isAllInOneSubscriptionActive", null),
    };
};

jarvisOnestockOnboardingParser.submitRiskAssessmentQuestion = (res) => {
    if (res && res.response) {
        res = res.response;
    }

    if (res && res.result) {
        res = res.result;
    }

    if (!res || !Object.keys(res).length) {
        return {};
    }

    return {
        riskProfileId: _get(res, "riskProfileId", null),
        riskProfileName: _get(res, "riskProfileName", null),
    };
};



export { jarvisOnestockOnboardingParser };
